import { canAnswerExigencia, hasOpenExigencia, isExigenciaExpired, isOpenExigencia } from './exigenciaResposta';

// O que o detalhe do processo oferece a cada perfil. `process:access` também está nos perfis de
// requerente, então a permissão sozinha não separa ato do órgão de ato do requerente; a API
// recusa o requerente com 403 nessas ações (change travas-fluxo-licenciamento).
export function processDetailActions({ requester = false, consultoria = false } = {}) {
  const orgao = !requester;
  return {
    transitionProcess: orgao,
    newMove: orgao && !consultoria,
    routeMove: orgao && !consultoria,
    analyzeExigencia: orgao,
    manageTaxes: orgao,
    analysisChecklist: orgao,
    removeDocument: orgao,
    addDocument: true,
    downloadDocument: true,
  };
}

export function showAnswerAction({ requester, move, now = new Date() }) {
  return Boolean(requester) && canAnswerExigencia(move, now);
}

/** Exigência aberta mas vencida: o requerente vê a orientação de pedir prorrogação. */
export function showExpiredNotice({ requester, move, now = new Date() }) {
  return Boolean(requester) && isOpenExigencia(move) && isExigenciaExpired(move, now);
}

export function showDocumentsAnswerWarning({ requester, moves }) {
  return Boolean(requester) && hasOpenExigencia(moves);
}
